import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import SearchBox from '../../components/CustomWidgets/SearchBox';
import i18next from "i18next";
import { useTranslation } from 'react-i18next';
import Plus from "@mui/icons-material/Add";
import { useState, useCallback, useEffect } from 'react';
// import PromotionsNodataImage from '../../assets/Images/no-data-promotions.png';
import BackArrow from "@mui/icons-material/ArrowBackIosNew";
import { AutoComplete, Input } from 'antd'
import { debounce } from "@mui/material";
import { getInventoryallproducts } from "../../API  Functions/InventoryFunctions";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import dummy_image from "../../assets/Images/gallery.svg";
import deleteicon from "../../assets/Order/Delete.svg";
import axiosInstance from "../../AxiosInstance";
import { URLS } from '../../API/API endpoints';
import PromotionsTable from './PromotionsTable';
import { Select } from "antd";
import { Modal } from "antd"
import {
    getGroupProducts,
    getProductGroups,
} from "../../API  Functions/productGroupFunctions";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import { DatePicker } from "antd";
import dayjs from "dayjs"
import { useMemo } from "react";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);



const Promotions = () => {
    const { t, i18n } = useTranslation();
    const [promotions, setPromotions] = useState([]);
    const [showCreatePromotion, setShowCreatePromotion] = useState(false);
    const [activeTab, setActiveTab] = useState("product");
    const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [Productoptions, setProductoptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [orderLines, setOrderLines] = useState([]);
    const [searching, setSearching] = useState(false);
    const [currentstep, setCurrentStep] = useState(1);
    const [selectedChannel, setSelectedChannel] = useState("pos");
    const [promotionType, setPromotionType] = useState("percentage")
    const [amount, setAmount] = useState(0);
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [promotionOn, setPromotionOn] = useState("")
    const [currentLimit, setCurrentLimit] = useState(10); // Default limit
    const [currentOffset, setCurrentOffset] = useState(0); // Default Offset
    const [originalPromotions, setOriginalPromotions] = useState([])
    const [selectedPromotion, setSelectedPromotion] = useState(null)
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedBrands, setSelectedBrands] = useState([])
    const [loading, setloading] = useState(false)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [productGroups, setProductGroups] = useState([])
    const [groups, setGroups] = useState([])
    const [selectedBrandIds, setSelectedBrandIds] = useState([])
    const [brandSearchQuery, setBrandSearchQuery] = useState("")
    const [brandOptions, setBrandOptions] = useState([])
    const [showBrandDropdown, setShowBrandDropdown] = useState(false)



    // remove: const [disabled, setDisabled] = useState(true)

    const isStepInvalid = useMemo(() => {
        // Step 1 — pick what the promo applies to
        if (currentstep === 1) {
            if (activeTab === "product") return orderLines.length === 0;
            if (activeTab === "groups") return selectedBrandIds.length === 0;
            return true;
        }

        // Step 2 — promotional rules
        if (currentstep === 2) {
            const amt = Number(amount);
            const hasDates = startDate && endDate;
            const datesValid = hasDates && dayjs(endDate).isSameOrAfter(dayjs(startDate));
            const prt = promotionType

            return (

                Number.isNaN(amt) ||
                amt <= 0 ||
                (prt === "percentage" && amt>100 )||
                !hasDates ||
                !datesValid 
            );
        }

        // Step 3 (product flow only) — review/confirm; nothing to fill, so enabled
        if (currentstep === 3) return false;

        return true; // unknown step → safe default
    }, [
        currentstep,
        activeTab,
        orderLines.length,
        selectedBrandIds.length,
        promotionType,
        amount,
        startDate,
        endDate,
        selectedChannel,
    ]);



    const categories = [
        "All",
        "Bakery",
        "Fruits",
        "Household essentials",
        "Vegetables",
        "Personal Care",
        "Dental Care",
        "Feminine Hygiene",
        "Beauty & Cosmetics",
        "Hair Care",
        "Quick Bites",
        "Skincare",
    ];
    const brands = [
        "Abu Auf",
        "Nescafe",
        "Juhayna",
        "Johnsons",
        "Maggie"
    ]

    useEffect(() => {
        if (groups.length > 0) {
            setBrandOptions(groups);
        }
    }, [groups]);

    const maxStep = activeTab === "product" ? 3 : 2
    useEffect(() => {
        getAllPromotions();
    }, [currentLimit, currentOffset]);
    const userData = useSelector((state) => state?.login?.user?.result);
    const handleDeleteLine = (id) => {
        setOrderLines((prev) => prev.filter((line) =>
            line.prod_id !== id && line.product_id !== id  // ✅ handle both
        ));
    };

    const handleDisable = () => {
        if (currentstep === 1) {
            if (activeTab === "product") {
                // Disable if no products are added
                return orderLines.length === 0;
            }
            if (activeTab === "groups") {
                // Disable if no brands are selected
                return selectedBrandIds.length === 0;
            }
        }

        if (currentstep === 2) {
            // Disable if any required promotional rule fields are missing
            return (
                !promotionType ||
                !amount ||
                Number(amount) <= 0 ||
                !startDate ||
                !endDate ||
                !selectedChannel
            );
        }

        return false;
    };

    const handleBrandSelect = (groupId) => {
        const alreadySelected = selectedBrandIds.includes(groupId);
        if (alreadySelected) {
            setSelectedBrandIds((prev) => prev.filter((id) => id !== groupId));
        } else {
            setSelectedBrandIds((prev) => [...prev, groupId]);
        }
    };
    const GetGroups = async (text = "") => {
        const payload = {
            lang: i18n.language === "ar" ? "ar_001" : "en_US",
            search: text,
            company_id: company_id,
            user_id: user_id,
            offset: currentOffset,
            limit: currentLimit,
        };
        try {
            const res1 = await getProductGroups(payload);

            console.log(res1)


            // console.log("res1---->", res1);

            if (res1?.result[0]?.status_code === 200) {
                setGroups(res1?.result[0]?.product_groups);
            } else {
                setGroups([]);
            }
        } catch (error) {
            console.error("Error fetching KPI data:", error);
            setloading(false);
        } finally {
            setloading(false);
        }
    };

    useEffect(() => {
        GetGroups()
    }, [])

    const searchBrands = useCallback(
        debounce((value) => {
            if (!value || value.length < 1) {
                setBrandOptions(groups);
            } else {
                setBrandOptions(
                    groups.filter((g) =>
                        g.name?.toLowerCase().includes(value.toLowerCase()) ||
                        g.name_ar?.toLowerCase().includes(value.toLowerCase())
                    )
                );
            }
        }, 300),
        [groups],
    );

    const debouncedSearch = debounce((value) => {
        promotions.filter((promotion) => promotion.promotion_type.includes(value))
    }, 1000);


    const company_id = useSelector(
        (state) => state?.login?.user?.result?.company_id,
    );

    const handleRowClick = async (promotion) => {
        setSelectedPromotion(promotion);
        setOrderLines([]);
        setSelectedBrandIds([]);
        setShowCreatePromotion(true);
        setCurrentStep(1);

        const payload = { promotion_id: promotion.id };

        try {
            const res = await axiosInstance.post(URLS.GET_PROMOTION_DETAILS, payload);

            console.log(res)
            const data = res?.data?.result?.data;

            console.log(data.promotion_type)

            setPromotionType(data.promotion_type || "");
            setAmount(data.value || 0);
            setStartDate(data.start_date || "");
            setEndDate(data.end_date || "");
            setSelectedChannel(data.promotion_on || "");
            setActiveTab("product");
            setOrderLines(data.products || []);
            if (data.apply_on === "groups" && data.brand_ids?.length) {
                setSelectedBrandIds(data.brand_ids);
            }


        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch promotion details.");
        }
    };
    const confirmDelete = (promotion) => {
        console.log("request reached on confirm delete")
        setSelectedPromotion(promotion)
        setShowConfirmModal(true)
    }

    const handlePromotionUpdate = async (promotion) => {
        try {
            const payload = {
                id: selectedPromotion.id,
                start_date: startDate,
                end_date: endDate,
                promotion_type: promotionType,
                value: parseFloat(amount) || 0,
                promotion_on: 'pos',
                apply_on: activeTab,
                ...(activeTab === "product"
                    ? { product_ids: orderLines.map((line) => line.prod_id ?? line.product_id) }
                    : { group_ids: selectedBrandIds }),
            }

            const res = await axiosInstance.post(URLS.UPDATE_PROMOTIONS, payload)
            const result = res?.data?.result
            if (result?.status_code === 200) {
                toast.success(t("Group updated successfully"));
                setShowCreatePromotion(false)
                setSelectedPromotion(false)
                await getAllPromotions()
            } else {
                toast.error(result?.status || "Failed to update promotion");
            }
        }
        catch (error) {
            console.log(error)
            toast.error(t("Failed to update promotion"));
        }
    }

    const handleDeletePromotion = async (promotion) => {
        try {
            setloading(true)

            const payload = {
                promotion_id: promotion.id
            }
            const res = await axiosInstance.post(URLS.DELETE_PROMOTIONS, payload)
            console.log(res?.data)

            if (res?.data?.result?.status_code === 200) {
                toast.success(t("Promotion removed successfully"));

                await getAllPromotions();
                setShowConfirmModal(false);
            } else {
                toast.error(res?.status || "Failed to remove products from group");
            }
        }
        catch (error) {
            console.log(error)
            toast.error(t("Failed to remove products from group"));
        }
    }
    const handleProductSelect = (value) => {
        const selectedProduct = Productoptions.find(
            (product) => product.product_name === value,
        );

        if (!selectedProduct) return;

        // 🚫 No barcode → open modal
        // if (!selectedProduct.barcode) {
        //     setSelectedProduct(selectedProduct);
        //     setSelectedProductId(selectedProduct.quant_id);
        //     return;
        // }

        // 🚫 Duplicate check
        const isDuplicate = orderLines.some(
            (product) => product.prod_id === selectedProduct.quant_id || product.production_id === selectedProduct.quant_id,
        );

        if (isDuplicate) {
            toast.error(`${selectedProduct.product_name} is already in the list.`);
            return;
        }

        // ✅ Map Productoptions → orderLines structure
        const mappedProduct = {
            barcode: selectedProduct.barcode,
            machine_barcode: selectedProduct.machine_barcode,
            weight: 0,
            prod_id: selectedProduct.quant_id,
            name:
                selectedProduct.product_name2 && selectedProduct.product_name2 != ""
                    ? selectedProduct.product_name2
                    : selectedProduct.product_name,
            sale_price:
                selectedProduct.discounted_price ?? selectedProduct.current_price,
            qty_available: selectedProduct.system_quantity,
            forecasted_qty: selectedProduct.system_quantity,
            image_url: selectedProduct.product_image_url,
            is_loose: false,
            uom: selectedProduct.uom,
            product_type: "sp",
            is_favorite: false,
            product_main_categ: selectedProduct.categ_id,
            discount_master_id: false,
            discount_qty: selectedProduct.prod_discount ?? 0,
            discount_type: false,
            product_selling_units: [],
            is_package: false,
        };

        // ✅ Add to order lines
        setOrderLines((prev) => [...prev, mappedProduct]);
    };

    function showCreatePromotionModal() {
        setSelectedPromotion(null);  // ✅ clear edit state
        setOrderLines([]);
        setSelectedBrandIds([]);       // ✅ add
        setBrandSearchQuery("");        // ✅ clear previous products
        setPromotionType("");
        setAmount(0);
        setStartDate("");
        setEndDate("");
        setSelectedChannel("");
        setActiveTab("product");
        setCurrentStep(1);
        setSearchQuery("");
        setShowCreatePromotion(true);
    }
    const searchResult = useCallback(
        debounce(async (value) => {
            setSearching(true);
            try {
                let payload = {};
                const response = await getInventoryallproducts(
                    user_id,
                    company_id,
                    false,
                    false,
                    value,
                    10,
                    0,
                );
                console.log("response==>", response);

                if (response?.result[0]?.response) {
                    setProductoptions(response.result[0].response);
                } else {
                    setProductoptions([]);
                }
            } catch (error) {
                console.error(error);
                setProductoptions([]);
            } finally {
                setSearching(false);
            }
        }, 1000),
        [user_id, company_id],
    );

    const handlePromotionCreate = async () => {
        try {
            const payload = {
                company_id: company_id,
                start_date: startDate,
                end_date: endDate,
                promotion_type: promotionType,
                value: parseFloat(amount) || 0,
                apply_on: activeTab,
                promotion_on: 'pos',
                ...(activeTab === "product"
                    ? { product_ids: orderLines.map((line) => line.prod_id) }
                    : { group_ids: selectedBrandIds }),
            };

            const response = await axiosInstance.post(URLS.CREATE_PROMOTION, payload);

            console.log(response)
            if (response?.data) {
                toast.success("Promotion created successfully!");
                setShowCreatePromotion(false);
                setSelectedPromotion(null);  // ✅ reset edit state
                setSearchQuery("");
                setOrderLines([]);
                setSelectedBrandIds([]);

                setPromotionType("");
                setAmount(0);
                setStartDate("");
                setEndDate("");
                setSelectedChannel("");
                setCurrentStep(1);
                await getAllPromotions();
            }
        } catch (error) {
            toast.error("Failed to create promotion. Please try again.");
            console.error(error);
        }
    };

    const handleSearch = useCallback(
        debounce((value) => {
            if (!value || value.trim() === "") {
                setPromotions(originalPromotions);
            } else {
                const filtered = originalPromotions.filter((promotion) =>
                    promotion.promotion_type?.toLowerCase().includes(value.toLowerCase())
                );
                setPromotions(filtered);
            }
        }, 500),
        [originalPromotions],
    );

    const getAllPromotions = async () => {
        try {
            const payload = {
                company_id: company_id,
                limit: currentLimit,
                offset: currentOffset
            };
            const response = await axiosInstance.post(URLS.GET_PROMOTIONS, payload);
            console.log(response?.data?.result?.data)
            if (response?.data) {
                setPromotions(response?.data?.result?.data);
                setOriginalPromotions(response?.data?.result?.data);
            }
        } catch (error) {
            toast.error("Failed to fetch promotions.");
            console.error(error);
        }
    };

    const options = [
        {
            value: "percentage",
            label: `${t("Percentage")}`
        },
        {
            value: "fixed",
            label: `${t("Fixed")}`
        }
    ]

    return (
        <>
            <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
                <Navbar heading={t("Promotions")} />
                <div className="custom-scrollbar ms-1 mt-2 flex-grow overflow-y-auto overflow-hidden sm:ms-3">
                    <div className="font-extrabold mb-3"></div>
                    <div className="mt-3">
                        <div className="flex justify-between mt-3 me-8">
                            {/* <SearchBox
                                placeholder={t("Search by promotion type")} searchResult={handleSearch} /> */}
                                <div className='w-8'>

                                </div>
                            <button
                                className="flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48"
                                onClick={() => {
                                    showCreatePromotionModal();
                                }}
                            >
                                <Plus style={{ fontSize: "1.5em", MozMarginStart: -10 }} />

                                <span>{t("Create Promotion")}</span>
                            </button>
                        </div>
                        {!promotions.length ? (
                            <div className="flex h-[60vh] w-full flex-col items-center justify-center gap-4">
                                {/* <img src={PromotionsNodataImage} style={{ width: 289, height: 256 }} alt="No Promotions" /> */}
                                <h1 className="font-semibold" style={{ fontSize: "27px" }}>{t("No Promotions Yet!")}</h1>
                                <p className="text-[#64748B]">{t("Start one now to bring more customers to your store!")}</p>
                            </div>
                        ) : (
                            <>
                                <PromotionsTable additionalData={promotions}
                                    showEdit={!userData?.is_sub_store && !userData?.is_warehouse}
                                    pagination={(values) => {
                                        setCurrentLimit(values.limit);
                                        setCurrentOffset(values.offset);
                                        {
                                            console.log("Pagination values:", values);
                                        }
                                    }}
                                    onRowClick={handleRowClick}
                                    onDelete={confirmDelete}
                                    onEditLine={handleRowClick}
                                />
                            </>
                        )}
                    </div>
                </div>
                {showCreatePromotion && (
                    <div className="fixed inset-0 z-40 bg-black bg-opacity-50">

                        {/* Drawer */}
                        <div
                            className={`fixed top-0 right-0 z-50 h-screen w-[500px] bg-white shadow-lg
                transform transition-transform duration-300 flex flex-col
                ${showCreatePromotion ? "translate-x-0" : "translate-x-full"}`}
                        >
                            {/* ── FIXED HEADER ── */}
                            <div className="flex-shrink-0 px-6 pt-6 pb-4 border-b border-gray-200">

                                {/* Row 1: Back arrow + Title + Action buttons */}
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        <BackArrow
                                            style={{ fontSize: "1.5em", cursor: "pointer", width: "37px", height: "21px" }}
                                            onClick={() => setShowCreatePromotion(false)}
                                        />
                                        <span className="text-xl font-bold">
                                            {t("Create Promotion")}
                                        </span>
                                    </div>

                                    {/* Action buttons pinned to top-right */}
                                    <div className="flex gap-2">
                                        {currentstep > 1 && (
                                            <button
                                                onClick={() => setCurrentStep((prev) => prev - 1)}
                                                className="px-4 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50"
                                            >
                                                {t("Back")}
                                            </button>
                                        )}
                                        <button
                                            disabled={isStepInvalid}
                                            onClick={() => {
                                                if (currentstep < maxStep) {
                                                    setCurrentStep((prev) => prev + 1);
                                                } else {
                                                    selectedPromotion
                                                        ? handlePromotionUpdate()
                                                        : handlePromotionCreate();
                                                }
                                            }}
                                            className={`px-5 py-1.5 text-sm font-semibold border rounded-lg transition-colors disabled:opacity-50 bg-primaryBlue text-white hover:opacity-90 border-primaryBlue"
                                                }`}
                                        >
                                            {currentstep === maxStep ? t("Finish") : t("Next")}
                                        </button>
                                    </div>
                                </div>

                                {/* Row 2: Tabs — only on step 1 */}
                                {currentstep === 1 && (
                                    <ul className="flex mt-4 border-b border-gray-300 list-none justify-around items-center"
                                        style={{ fontSize: "13px" }}>
                                        <li
                                            onClick={() => { setActiveTab("product"); setCurrentStep(1); }}
                                            className={`cursor-pointer pb-2 border-b-2 ${activeTab === "product"
                                                ? "border-sky-500 text-[#343C6A] font-semibold"
                                                : "border-transparent text-[#5B75A1]"}`}
                                        >
                                            Product
                                        </li>
                                        <li
                                            onClick={() => { setActiveTab("groups"); setCurrentStep(1); }}
                                            className={`cursor-pointer pb-2 border-b-2 ${activeTab === "groups"
                                                ? "border-sky-500 text-[#343C6A] font-semibold"
                                                : "border-transparent text-[#5B75A1]"}`}
                                        >
                                            Product Groups
                                        </li>
                                    </ul>
                                )}
                            </div>

                            {/* ── SCROLLABLE BODY ── */}
                            <div className="flex-1 overflow-y-auto px-6 py-4">

                                {/* Step 1 - Product tab */}
                                {currentstep === 1 && activeTab === "product" && (
                                    <>
                                        {/* Search */}
                                        <div className="relative w-full mb-4">
                                            <AutoComplete
                                                value={searchQuery}
                                                style={{ width: "100%", height: "43px" }}
                                                open={showDropdown}
                                                onDropdownVisibleChange={(open) => setShowDropdown(open)}
                                                options={Productoptions.map((prod) => ({
                                                    value: prod.product_name,
                                                    label: (
                                                        <div className="flex justify-between items-center">
                                                            <span>
                                                                {prod.product_name2 && prod.product_name2 !== ""
                                                                    ? prod.product_name2
                                                                    : prod.product_name}
                                                            </span>
                                                            {orderLines.some((p) => p.prod_id === prod.quant_id) && (
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                                                    stroke="#16A34A" strokeWidth="3"
                                                                    strokeLinecap="round" strokeLinejoin="round">
                                                                    <polyline points="20 6 9 17 4 12" />
                                                                </svg>
                                                            )}
                                                        </div>
                                                    ),
                                                    disabled: orderLines.some((p) => p.prod_id === prod.quant_id),
                                                }))}
                                                filterOption={false}
                                                onSearch={(val) => {
                                                    setSearchQuery(val);
                                                    if (val.length >= 2) {
                                                        searchResult(val);
                                                        setShowDropdown(true);
                                                    } else {
                                                        setProductoptions([]);
                                                        setShowDropdown(false);
                                                    }
                                                }}
                                                onSelect={(val) => {
                                                    setTimeout(() => setShowDropdown(true), 0);
                                                    handleProductSelect(val);
                                                }}
                                            >
                                                <Input
                                                    placeholder={t("search_product")}
                                                    size="large"
                                                    style={{ borderColor: "#d9d9d9", boxShadow: "none" }}
                                                    suffix={
                                                        searchQuery ? (
                                                            <CloseOutlined
                                                                onClick={() => { setShowDropdown(false); setSearchQuery(""); setProductoptions([]) }}
                                                                style={{ cursor: "pointer" }}
                                                            />
                                                        ) : (
                                                            <SearchOutlined />
                                                        )
                                                    }
                                                />
                                            </AutoComplete>
                                        </div>

                                        {/* Added Products badge */}
                                        <div className="flex items-center justify-between rounded-lg bg-[#F1F2F666] px-4 py-3 mb-4">
                                            <div className="flex items-center gap-2">
                                                <div className="h-2 w-2 rounded-full bg-primaryBlue"></div>
                                                <span className="text-sm font-semibold tracking-wide text-[#343C6A]">
                                                    {t("Added Products")}
                                                </span>
                                            </div>
                                            <span className="rounded-full bg-white px-2 py-1 text-xs font-medium text-[#5B75A1] shadow-sm">
                                                {orderLines.length}
                                            </span>
                                        </div>

                                        {/* Product list — naturally scrolls with the body */}
                                        <div className="space-y-2">
                                            {selectedPromotion && orderLines.map((line) => (
                                                <div key={line.product_id}
                                                    className="flex justify-between items-center border rounded-lg bg-white p-2 shadow-sm">
                                                    <img
                                                        src={line.image_url || line.product_image_url || dummy_image}
                                                        alt={line.name || line.product_name}
                                                        className="w-10 h-10 object-contain rounded flex-shrink-0"
                                                    />
                                                    <div className="flex flex-1 flex-col mx-2">
                                                        <p className="text-[12px] font-semibold text-gray-800 leading-tight">
                                                            {line.name || line.product_name}
                                                        </p>
                                                    </div>
                                                    {!userData?.is_sub_store && !userData?.is_warehouse && (
                                                        <button
                                                            onClick={() => handleDeleteLine(line.product_id)}
                                                            className="flex h-9 w-9 items-center justify-center rounded-full bg-red-50 hover:bg-red-100"
                                                        >
                                                            <img src={deleteicon} alt="Delete" className="h-4 w-4" />
                                                        </button>
                                                    )}
                                                </div>
                                            ))}

                                            {!selectedPromotion && orderLines.map((line) => (
                                                <div key={line.prod_id}
                                                    className="flex justify-between items-center border rounded-lg bg-white p-2 shadow-sm">
                                                    <img
                                                        src={line.image_url || dummy_image}
                                                        alt=""
                                                        className="w-10 h-10 object-contain rounded flex-shrink-0"
                                                    />
                                                    <div className="flex flex-col flex-1 mx-2">
                                                        <p className="font-semibold text-[12px] leading-tight">
                                                            {line.name || line.product_name}
                                                        </p>
                                                        <p className="text-xs text-gray-600">{line.barcode}</p>
                                                    </div>
                                                    <p className="font-normal whitespace-nowrap text-right mr-3 text-[12px]">
                                                        EGP {line.sale_price ? line.sale_price.toFixed(2) : line.current_price}
                                                    </p>
                                                    {!userData?.is_sub_store && !userData?.is_warehouse && (
                                                        <img
                                                            src={deleteicon}
                                                            className="cursor-pointer h-4 w-4 mx-2"
                                                            alt="Delete"
                                                            onClick={() => handleDeleteLine(line.prod_id)}
                                                        />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}

                                {/* Step 1 - Brand tab */}
                                {currentstep === 1 && activeTab === "groups" && (
                                    <>
                                        <AutoComplete
                                            value={brandSearchQuery}
                                            style={{ width: "100%", height: "43px" }}
                                            open={showBrandDropdown}
                                            onDropdownVisibleChange={(open) => setShowBrandDropdown(open)}
                                            options={brandOptions.map((group) => ({
                                                value: String(group.id),
                                                label: (
                                                    <div className="flex justify-between items-center">
                                                        <div className="flex flex-col">
                                                            <span className="text-sm font-semibold">{group.name}</span>
                                                            <span className="text-xs text-gray-400">
                                                                {group.no_of_products} products · {group.created_by}
                                                            </span>
                                                        </div>
                                                        {selectedBrandIds.includes(group.id) && (
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                                                stroke="#16A34A" strokeWidth="3"
                                                                strokeLinecap="round" strokeLinejoin="round">
                                                                <polyline points="20 6 9 17 4 12" />
                                                            </svg>
                                                        )}
                                                    </div>
                                                ),
                                            }))}
                                            filterOption={false}
                                            onSearch={(val) => {
                                                setBrandSearchQuery(val);
                                                setBrandOptions(
                                                    val.length >= 1
                                                        ? groups.filter((g) =>
                                                            g.name?.toLowerCase().includes(val.toLowerCase()) ||
                                                            g.name_ar?.toLowerCase().includes(val.toLowerCase()))
                                                        : groups
                                                );
                                                setShowBrandDropdown(true);
                                            }}
                                            onSelect={(val) => {
                                                handleBrandSelect(Number(val));
                                                setBrandSearchQuery("");
                                                setBrandOptions(groups);
                                                setTimeout(() => setShowBrandDropdown(true), 0);
                                            }}
                                        >
                                            <Input
                                                placeholder={t("Search Product Groups")}
                                                size="large"
                                                style={{ borderColor: "#d9d9d9", boxShadow: "none" }}
                                                suffix={
                                                    brandSearchQuery ? (
                                                        <CloseOutlined
                                                            onClick={() => { setBrandSearchQuery(""); setBrandOptions(groups); setShowBrandDropdown(true); }}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    ) : <SearchOutlined />
                                                }
                                            />
                                        </AutoComplete>

                                        {/* Selected count badge */}
                                        <div className="mt-4 mb-3 flex items-center justify-between rounded-lg bg-[#F1F2F666] px-4 py-3">
                                            <div className="flex items-center gap-2">
                                                <div className="h-2 w-2 rounded-full bg-primaryBlue"></div>
                                                <span className="text-sm font-semibold tracking-wide text-[#343C6A]">
                                                    {t("Selected Product Groups")}
                                                </span>
                                            </div>
                                            <span className="rounded-full bg-white px-2 py-1 text-xs font-medium text-[#5B75A1] shadow-sm">
                                                {selectedBrandIds.length}
                                            </span>
                                        </div>

                                        {/* Brand list — scrolls naturally */}
                                        <div className="space-y-2">
                                            {selectedBrandIds.length === 0 ? (
                                                <div className="flex h-32 items-center justify-center text-sm text-gray-400">
                                                    {t("No Product groups selected yet")}
                                                </div>
                                            ) : (
                                                groups
                                                    .filter((g) => selectedBrandIds.includes(g.id))
                                                    .map((group) => (
                                                        <div key={group.id}
                                                            className="flex items-center justify-between rounded-lg border border-gray-200 bg-white p-3 shadow-sm">
                                                            <div className="flex flex-col">
                                                                <p className="text-sm font-semibold text-[#343C6A]">{group.name}</p>
                                                                {group.name_ar && <p className="text-xs text-gray-400">{group.name_ar}</p>}
                                                                <p className="text-xs text-gray-400 mt-0.5">
                                                                    {group.no_of_products} products · {group.created_by}
                                                                </p>
                                                            </div>
                                                            <button
                                                                onClick={() => handleBrandSelect(group.id)}
                                                                className="flex h-9 w-9 items-center justify-center rounded-full bg-red-50 hover:bg-red-100"
                                                            >
                                                                <img src={deleteicon} alt="Remove" className="h-4 w-4" />
                                                            </button>
                                                        </div>
                                                    ))
                                            )}
                                        </div>
                                    </>
                                )}

                                {/* Step 2 */}
                                {currentstep === 2 && (
                                    <div className="space-y-5 text-[12px]">
                                        <div className="flex gap-4">
                                            <div className="flex-1">
                                                <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                    {t("Promotion Type")}
                                                </label>
                                                <SelectBox
                                                    // style={{ width: 40 }}
                                                    // width={140}
                                                    placeholder={"Select Promotion Type"}
                                                    name="filter"
                                                    onChange={(e) => {
                                                        console.log(e.target.value)
                                                        setPromotionType(e.target.value)
                                                    }}
                                                    options={options}
                                                    value={promotionType }
                                                />
                                            </div>
                                            <div className="flex-1">
                                                <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                    {t("Amount")}
                                                </label>
                                                <input
                                                    type="number"
                                                    placeholder={t("Enter amount")}
                                                    className="w-full rounded-lg border border-gray-300 p-3 outline-none focus:border-primaryBlue"
                                                    onChange={(e) => setAmount(e.target.value)}
                                                    value={amount}
                                                />
                                                {
                                                    promotionType === "percentage" && Number(amount) > 100 ? (
                                                        <p style={{color:"red", fontSize:"12px"}}>
                                                            Percentage cannot be greater than 100
                                                        </p>
                                                    ) : null
                                                }
                                            </div>
                                        </div>

                                        <div className="flex gap-4">
                                            <div className="flex-1">
                                                <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                    {t("Start Date")}
                                                </label>
                                                <DatePicker
                                                    className="w-full"
                                                    format="YYYY-MM-DD"
                                                    value={startDate ? dayjs(startDate) : null}
                                                    onChange={(date) => setStartDate(date ? date.format("YYYY-MM-DD") : "")}
                                                    disabledDate={(current) => current && current < dayjs().startOf("day")}
                                                />
                                            </div>
                                            <div className="flex-1">
                                                <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                    {t("End Date")}
                                                </label>
                                                <DatePicker
                                                    className="w-full"
                                                    format="YYYY-MM-DD"
                                                    value={endDate ? dayjs(endDate) : null}
                                                    onChange={(date) => setEndDate(date ? date.format("YYYY-MM-DD") : "")}
                                                    disabledDate={(current) => current && current < (startDate ? dayjs(startDate) : dayjs().startOf("day"))}
                                                />
                                            </div>
                                        </div>

                                        {/* <div className="flex flex-col">
                                            <label className="mb-1 block text-[11px] font-medium text-gray-700">
                                                {t("Promotion On")}
                                            </label>

                                            <div className="flex gap-2 mt-1">
                                                {[
                                                    { label: "E-com", value: "ecom" },
                                                    { label: "POS", value: "pos" },
                                                    { label: "Both", value: "both" },
                                                ].map((ch) => (
                                                    <div
                                                        key={ch.value}
                                                        onClick={() => setSelectedChannel(ch.value)}
                                                        className={`flex-1 h-[48px] rounded-[8px] flex justify-center items-center cursor-pointer border transition-all
                ${selectedChannel === ch.value
                                                                ? "border-blue-500 bg-[#EEF2FF] text-blue-600 font-semibold"
                                                                : "border-gray-200 bg-white text-gray-500 font-medium"
                                                            }`}
                                                    >
                                                        <span className="text-[13px]">{ch.label}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div> */}
                                    </div>
                                )}

                                {/* Step 3 - Summary (product tab only) */}
                                {currentstep === 3 && activeTab === "product" && (
                                    <div className="space-y-5">
                                        <div className="flex gap-4">
                                            <div className="flex-1 rounded-lg border border-gray-200 bg-[#F8FAFF] p-3">
                                                <p className="text-xs text-gray-500 mb-1">{t("Promotion Type")}</p>
                                                <p className="font-semibold text-sm text-[#343C6A] capitalize">{promotionType || "—"}</p>
                                            </div>
                                            <div className="flex-1 rounded-lg border border-gray-200 bg-[#F8FAFF] p-3">
                                                <p className="text-xs text-gray-500 mb-1">{t("Amount")}</p>
                                                <p className="font-semibold text-sm text-[#343C6A]">
                                                    {promotionType === "percentage" ? `${amount}%` : `EGP ${Number(amount).toFixed(2)}`}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="flex gap-4">
                                            <div className="flex-1 rounded-lg border border-gray-200 bg-[#F8FAFF] p-3">
                                                <p className="text-xs text-gray-500 mb-1">{t("Start Date")}</p>
                                                <p className="font-semibold text-sm text-[#343C6A]">{startDate || "—"}</p>
                                            </div>
                                            <div className="flex-1 rounded-lg border border-gray-200 bg-[#F8FAFF] p-3">
                                                <p className="text-xs text-gray-500 mb-1">{t("End Date")}</p>
                                                <p className="font-semibold text-sm text-[#343C6A]">{endDate || "—"}</p>
                                            </div>
                                        </div>

                                        {/* <div>
                                            <p className="text-sm font-medium text-gray-700 mb-2">{t("Promotion On")}</p>
                                            <div className="flex gap-3">
                                                {[{ label: "E-com", value: "ecom" }, { label: "POS", value: "pos" }, { label: "Both", value: "both" }].map((channel) => (
                                                    <div key={channel.value}
                                                        className={`flex items-center gap-2 rounded-lg border-2 px-4 py-2 text-sm font-medium
                                            ${selectedChannel === channel.value
                                                                ? "border-primaryBlue bg-gray-50 text-primaryBlue"
                                                                : "border-gray-200 bg-gray-50 text-gray-400"}`}
                                                    >
                                                        <span className={`h-3 w-3 rounded-full border-2 flex-shrink-0
                                            ${selectedChannel === channel.value ? "border-primaryBlue bg-primaryBlue" : "border-gray-300 bg-white"}`}
                                                        />
                                                        {channel.label}
                                                    </div>
                                                ))}
                                            </div>
                                        </div> */}

                                        {/* Added Products — scrolls with the rest of the page */}
                                        <div>
                                            <div className="w-full bg-[#F1F2F6] text-center text-[13px] text-gray-500 py-1 rounded mb-3">
                                                {t("Added Products")} ({orderLines.length})
                                            </div>
                                            <div className="space-y-2">
                                                {selectedPromotion && orderLines.map((line) => (
                                                    <div key={line.product_id}
                                                        className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white p-2">
                                                        <div className="flex-shrink-0">
                                                            <img src={line.image_url || line.product_image_url || dummy_image}
                                                                alt={line.name || line.product_name}
                                                                className="w-8 h-8 object-contain rounded"
                                                            />
                                                        </div>
                                                        <div className="flex flex-1 flex-col min-w-0">
                                                            <p className="text-xs font-semibold text-gray-800 truncate">
                                                                {line.name || line.product_name}
                                                            </p>
                                                            <div className="flex items-center gap-2 mt-0.5">
                                                                <span className="text-[11px] font-medium text-green-600">
                                                                    EGP {line.discounted_price}
                                                                </span>
                                                                <span className="text-[11px] text-gray-400 line-through">
                                                                    EGP {line.original_price}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        {!userData?.is_sub_store && !userData?.is_warehouse && (
                                                            <button
                                                                onClick={() => handleDeleteLine(line.product_id)}
                                                                className="flex-shrink-0 flex h-7 w-7 items-center justify-center rounded-full bg-red-50 hover:bg-red-100"
                                                            >
                                                                <img src={deleteicon} alt="Delete" className="h-3 w-3" />
                                                            </button>
                                                        )}
                                                    </div>
                                                ))}
                                                {!selectedPromotion && orderLines.map((line) => (
                                                    <div key={line.prod_id}
                                                        className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-2">
                                                        <img src={line.image_url || dummy_image} alt=""
                                                            className="w-10 h-10 object-contain rounded flex-shrink-0"
                                                        />
                                                        <div className="flex flex-col flex-1 min-w-0">
                                                            <p className="font-semibold text-sm leading-tight truncate">{line.name}</p>
                                                            <p className="text-xs text-gray-400">{line.barcode}</p>
                                                        </div>
                                                        <p className="text-sm font-medium text-[#343C6A] whitespace-nowrap">
                                                            EGP {line.sale_price ? line.sale_price.toFixed(2) : "—"}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>{/* end scrollable body */}
                        </div>
                    </div>
                )}

                <Modal
                    open={showConfirmModal}
                    onCancel={() => setShowConfirmModal(false)}
                    footer={null}
                    centered
                    closable={false}
                >
                    <div className="text-center p-6">
                        <h3 className="text-lg font-semibold mb-4 text-gray-800">
                            {t("Are you sure you want to delete this promotion ?")}
                        </h3>
                        <div className="flex justify-center gap-4 mt-6">
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
                            >
                                {t("No")}
                            </button>
                            <button
                                onClick={() => handleDeletePromotion(selectedPromotion)} // ✅ fixed line
                                disabled={loading}
                                className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
                            >
                                {loading ? t("Removing...") : t("Yes")}
                            </button>
                        </div>
                    </div>
                </Modal>

            </div>
        </>
    )
}
export default Promotions;